import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/chemicals_task/page',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/carApplications/chemicals_task/check',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/carApplications/revoke',
    method: 'post',
    data,
  })
}
export async function getDetail(params) {
  return request({
    url: '/carApplications/task/detail',
    method: 'get',
    params,
  })
}
